import axios from 'axios';

const api = axios.create({
  baseURL: 'https://diwataparesoverload.vercel.app/flashbox/api/', // Base URL for backend
  headers: {
    'Content-Type': 'application/json',
  },
});


api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('authToken');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  
export default api;
